import React from 'react';

const MatchbackStepCheckIcon = (props: any) => {
  return (
    <svg
      width="7.27273"
      height="5"
      viewBox="0.5 0.5 7.27273 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.77273 0.5L2.77273 5.5L0.5 3.22727" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default MatchbackStepCheckIcon;
